import { render, staticRenderFns } from "./ImportStockLabo.vue?vue&type=template&id=1132e75c&"
import script from "./ImportStockLabo.vue?vue&type=script&lang=js&"
export * from "./ImportStockLabo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports